import { useState } from 'react';
import LoginPage from '../../pages/Login';

/**
 * サイトパスワード（プレオープン）ゲート。
 *
 * SITE_PASSWORD が設定されている間、公開ブラウズ（トップ "/"・"/about"）を
 * babak2026 入力の背後に置く。babak2026 を通過したら children を表示する。
 * SNS ログインは要求しない（閲覧だけならログイン不要のままにする）。
 *
 * 直接の共有リンク "/shared/:id" と QR の "/claim/:token" には適用しない
 * （受け取った相手がゲート無しで開けるよう、公開のまま）。
 *
 * SITE_PASSWORD 未設定時はバックエンドの /api/auth/me が sitePasswordRequired:false を
 * 返すため、LoginPage(mode='siteGate') が即 onSiteUnlock を呼び、ゲートは素通りになる。
 *
 * onUnlock: ゲート通過直後に呼ばれる。App の checkAuthStatus を渡すことで、site_access
 * Cookie 設定後の /api/auth/me（sitePasswordRequired:false）を読み直して SNS ユーザー情報を
 * 再ハイドレートする。これが無いと、ゲート初回チェックで捨てられた user/isAuthenticated が
 * null/false のまま残り、ログイン済みでも所有者操作やヘッダーが未ログイン表示になる。
 */
export default function SiteGate({ children, onUnlock }) {
  const [unlocked, setUnlocked] = useState(false);

  if (unlocked) {
    return children;
  }

  const handleUnlock = () => {
    setUnlocked(true);
    onUnlock?.();
  };

  return <LoginPage mode="siteGate" onSiteUnlock={handleUnlock} />;
}
